import { render } from "./BranchIndex.vue?vue&type=template&id=6b967a71"
import script from "./BranchIndex.vue?vue&type=script&lang=js"
export * from "./BranchIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__